import { render, staticRenderFns } from "./Repasses.vue?vue&type=template&id=78985c14&scoped=true&"
import script from "./Repasses.vue?vue&type=script&lang=js&"
export * from "./Repasses.vue?vue&type=script&lang=js&"
import style0 from "./Repasses.vue?vue&type=style&index=0&id=78985c14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78985c14",
  null
  
)

export default component.exports